import { useEffect, useMemo, useState } from "react";

const SCOPE_LABELS: Record<string, string> = {
  openid: "Verify your identity",
  profile: "Read your basic profile",
  email: "Read your email address",
  offline_access: "Stay connected (refresh access)",
};

// Mirrors the former server-rendered consent page. window.location.search is
// forwarded verbatim (minus the leading "?") as oauth_query so the signed
// authorize request round-trips untouched.
export function ConsentPage() {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const { clientId, scopes } = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const scopeList = (params.get("scope") || "").split(" ").filter(Boolean);
    return {
      clientId: params.get("client_id"),
      scopes: scopeList.length ? scopeList : ["openid"],
    };
  }, []);

  useEffect(() => {
    document.title = "Authorize · ultracoach";
  }, []);

  async function submit(accept: boolean) {
    setError("");
    setBusy(true);
    try {
      const res = await fetch("/api/auth/oauth2/consent", {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json", accept: "application/json" },
        body: JSON.stringify({
          accept,
          oauth_query: window.location.search.replace(/^\?/, ""),
        }),
      });
      const d = (await res.json().catch(() => ({}))) as {
        url?: string;
        error_description?: string;
        message?: string;
      };
      if (d?.url) {
        window.location.href = d.url;
        return;
      }
      setError(d.error_description || d.message || "Something went wrong");
      setBusy(false);
    } catch {
      setError("Network error");
      setBusy(false);
    }
  }

  return (
    <>
      <div className="mark">
        <i />
        <i />
        <i />
        <i />
      </div>
      <h1>Authorize access</h1>
      <p className="sub">
        <span>{clientId || "An application"}</span> wants to connect to your
        ultracoach data.
      </p>
      <ul className="scopes">
        {scopes.map((s) => (
          <li key={s}>{SCOPE_LABELS[s] || s}</li>
        ))}
      </ul>
      <button type="button" disabled={busy} onClick={() => submit(true)}>
        Approve
      </button>
      <button
        type="button"
        className="ghost"
        disabled={busy}
        onClick={() => submit(false)}
      >
        Deny
      </button>
      <div className="err">{error}</div>
    </>
  );
}
